import React, { useState } from "react";
const today = new Date();
const thisYear = today.getFullYear();
const thisMonth = today.getMonth() + 1;
const maxDayArr = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

export default class Calendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      state: "PERSONAL",
      mode: "list",
      date: new Date(props.year + "-" + props.month + "-" + props.today),
      year: props.year,
      month: props.month,
      startDate: new Date(props.year + "-" + props.month + "-" + props.today)
        .toISOString()
        .split("T")[0],
      startTime: "00:00",
      endDate: new Date(props.year + "-" + props.month + "-" + props.today)
        .toISOString()
        .split("T")[0],
      endTime: "18:00",
    };

    this.setStateToWrite = this.setStateToWrite.bind(this);
    this.writeSchedule = this.writeSchedule.bind(this);
    this.saveSchedule = this.saveSchedule.bind(this);
    this.timeSetForStartTime = this.timeSetForStartTime.bind(this);
    this.timeSetForEndTime = this.timeSetForEndTime.bind(this);
    this.startDateSet = this.startDateSet.bind(this);
    this.endDateSet = this.endDateSet.bind(this);
    this.makeScheduleList = this.makeScheduleList.bind(this);
    this.removeSchedule = this.removeSchedule.bind(this);
    this.setDateForView = this.setDateForView.bind(this);
    this.modifySchedule = this.modifySchedule.bind(this);
    this.setTitleForIM = this.setTitleForIM.bind(this);
    this.changeState = this.changeState.bind(this);
    this.getScheduleSpans = this.getScheduleSpans.bind(this);
    this.makeEmptyDayTD = this.makeEmptyDayTD.bind(this);
  }

  setStateToWrite() {
    this.setState({ mode: "insert" });
  }

  writeSchedule(e) {
    this.setState({
      startDate: new Date(
        this.props.year +
          "-" +
          this.props.month +
          "-" +
          parseInt(e.target.innerHTML).toString()
      )
        .toISOString()
        .split("T")[0],
      endDate: new Date(
        this.props.year +
          "-" +
          this.props.month +
          "-" +
          parseInt(e.target.innerHTML).toString()
      )
        .toISOString()
        .split("T")[0],
    });
  }

  convertIntToDateString(num) {
    if (num.length === 1) return "0" + num;
    else return num;
  }

  setDateForView(e) {
    this.setState({
      startDate: new Date(
        this.props.year +
          "-" +
          this.props.month +
          "-" +
          this.convertIntToDateString(
            e.currentTarget.getAttribute("data-day") + " 12:00:00"
          )
      )
        .toISOString()
        .split("T")[0],
      endDate: new Date(
        this.props.year +
          "-" +
          this.props.month +
          "-" +
          this.convertIntToDateString(e.currentTarget.getAttribute("data-day"))
      )
        .toISOString()
        .split("T")[0],
    });

    // var xhr = new XMLHttpRequest();
    // xhr.open("POST", "/lib/schedule.php", false);
    // xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    // xhr.send(
    //   "cmd=view&year=" +
    //     this.props.year +
    //     "&month=" +
    //     this.props.month +
    //     "&day=" +
    //     e.currentTarget.getAttribute("data-day")
    // );
    // this.setState({ viewList: JSON.parse(xhr.responseText) });
  }

  makeScheduleList(e) {
    // const list = [];
    // for (var i = 0; i < this.state.viewList.length; i++) {
    //   list.push(
    //     <li className="row" key={this.state.viewList[i].ID.toString()}>
    //       <span className="col-6">
    //         [ {this.state.viewList[i].START_DATE} ~{" "}
    //         {this.state.viewList[i].END_DATE} ]
    //       </span>
    //       <span className={this.state.viewList[i].TYPE + " col-4"}>
    //         {this.state.viewList[i].TITLE}
    //         <input
    //           type="checkbox"
    //           name="complete"
    //           data-id={this.state.viewList[i].ID}
    //           defaultChecked={
    //             this.state.viewList[i].STATE == "COMPLETE" ? true : false
    //           }
    //           onChange={this.changeState}
    //         />
    //       </span>
    //       <span className="col-2">
    //         <button
    //           type="button"
    //           className="btn btn-outline-primary btn-sm"
    //           onClick={this.modifySchedule}
    //           data-id={this.state.viewList[i].ID}
    //           data-toggle="modal"
    //           data-target="#exampleModal"
    //         >
    //           수정
    //         </button>
    //         <button
    //           type="button"
    //           className="btn btn-outline-danger btn-sm"
    //           data-removeid={this.state.viewList[i].ID}
    //           onClick={this.removeSchedule}
    //         >
    //           삭제
    //         </button>
    //       </span>
    //     </li>
    //   );
    // }
    // return list;
  }

  changeState(e) {
    // e.persist();
    // e.stopPropagation();
    // e.nativeEvent.stopImmediatePropagation();
    // var complete = e.target.checked == true ? "COMPLETE" : "";
    // var xhr = new XMLHttpRequest();
    // xhr.open("POST", "/lib/schedule.php", false);
    // xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    // xhr.send(
    //   "cmd=complete&id=" +
    //     e.target.getAttribute("data-id") +
    //     "&state=" +
    //     complete
    // );
  }

  saveSchedule(e) {
    e.preventDefault();
    // var form = e.target;
    // var xhr = new XMLHttpRequest();
    // xhr.open("POST", "/lib/schedule.php", false);
    // xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    // var cmd = form.cmd.value;
    // var idQueryString = cmd == "insert" ? "" : "&id=" + form.id.value;
    // xhr.send(
    //   "cmd=" +
    //     cmd +
    //     idQueryString +
    //     "&startDate=" +
    //     form.startDate.value +
    //     " " +
    //     form.startTime.value +
    //     "&endDate=" +
    //     form.endDate.value +
    //     " " +
    //     form.endTime.value +
    //     "&title=" +
    //     form.title.value +
    //     "&type=" +
    //     form.type.value +
    //     "&state=" +
    //     form.state.value
    // );

    // if (xhr.responseText) window.location.reload();
    // else alert("error");
  }

  modifySchedule(e) {
    var target;
    for (var i = 0; i < this.state.viewList.length; i++) {
      var item = this.state.viewList[i];
      if (item.ID === e.target.getAttribute("data-id")) {
        target = item;
        this.setState({
          state: item.STATE,
          startDate: item.START_DATE.substr(0, 10),
          startTime: item.START_DATE.substr(11, 8),
          endDate: item.END_DATE.substr(0, 10),
          endTime: item.END_DATE.substr(11, 8),
        });
      }
    }
    this.setState({ mode: "modify", diary: target });
  }

  removeSchedule(e) {
    // var xhr = new XMLHttpRequest();
    // xhr.open("POST", "/lib/schedule.php", false);
    // xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    // xhr.send("cmd=delete&id=" + e.target.getAttribute("data-removeid"));
    // if (xhr.responseText == "true") window.location.reload();
    // else alert("삭제실패");
  }

  timeSetForStartTime(e) {
    this.setState({ startTime: e.target.value });
  }

  timeSetForEndTime(e) {
    this.setState({ endTime: e.target.value });
  }

  startDateSet(e) {
    this.setState({ startDate: e.target.value });
  }

  endDateSet(e) {
    this.setState({ endDate: e.target.value });
  }

  setTitleForIM(e) {
    this.setState({ title: e.target.value, diary: { TITLE: e.target.value } });
  }

  getScheduleSpans(list, day) {
    var spans = [];

    for (var i = 0; i < list.length; i++) {
      const keyName = list[i].ID;
      if (
        new Date(list[i].START_DATE).getFullYear() === this.props.year &&
        new Date(list[i].START_DATE).getMonth() + 1 === this.props.month &&
        new Date(list[i].START_DATE).getDate() === day
      ) {
        spans.push(
          <span
            key={keyName}
            className={
              list[i].DONE ? "bg-lime-500" : "bg-gray-200 rounded mr-1"
            }
          >
            {list[i].TITLE}
          </span>
        );
      } else if (
        new Date(
          this.props.year + "-" + this.props.month + "-" + day + " 00:00:00"
        ) > new Date(list[i].START_DATE) &&
        new Date(
          this.props.year + "-" + this.props.month + "-" + day + " 00:00:00"
        ) < new Date(list[i].END_DATE)
      ) {
        spans.push(
          <span key={keyName} className={list[i].TYPE}>
            {list[i].TITLE}
          </span>
        );
      }
    }
    return spans;
  }

  makeEmptyDayTD(year, month) {
    var emptyTD = [];
    var firdayNum = new Date(year + "-" + month + "-1").getDay();
    if (firdayNum !== 7) {
      for (var i = 0; i < firdayNum; i++) {
        emptyTD.push(
          <div
            className="flex justify-center items-center flex-1"
            key={"empty" + i.toString()}
          ></div>
        );
      }
    }
    return emptyTD;
  }

  makeDayObjArr() {
    const year = this.props.year;
    const month = this.props.month;
    const day = this.state.date.getDate();

    var dayQueue = this.makeDayNumQueue(this.props.year, this.props.month);
    //var holidayArr = this.getScheduleList(year, month);

    var DayObjArr = [];
    DayObjArr = this.makeEmptyDayTD(this.props.year, this.props.month);
    for (var i = 1; i <= maxDayArr[month - 1]; i++) {
      var targetDay = dayQueue.shift();
      var classValue =
        "inline-block flex-1 h-30 border " +
        (year === new Date().getFullYear() &&
        month === new Date().getMonth() + 1 &&
        day === i
          ? "outline outline-2 outline-gray-400"
          : "") +
        (targetDay === 6 ? "bg-[#E3F7FE]" : "") +
        (targetDay === 7 ? "bg-[#FFEDED]" : "");
      console.log(this.props.scheduleList);
      var scheduleSpans = this.getScheduleSpans(this.props.scheduleList, i);
      DayObjArr.push(
        <div
          className={classValue}
          key={"td" + i.toString()}
          data-day={i.toString()}
          data-toggle="modal"
          data-target="#viewModal"
          onClick={this.setDateForView}
        >
          <div key={"div" + i.toString()}>{i.toString()}</div>
          {scheduleSpans}
        </div>
      );
      dayQueue.push(targetDay);
    }
    var tdArr = [];
    var result = [];
    for (var j = 0; j < DayObjArr.length; j++) {
      tdArr.push(DayObjArr[j]);
      if (j > 1 && j % 7 === 6) {
        result.push(
          <div
            className="flex h-1/6"
            key={year.toString() + "-" + month.toString() + "-" + j.toString()}
          >
            {tdArr}
          </div>
        );
        tdArr = [];
      }
      if (j === DayObjArr.length - 1)
        result.push(
          <div
            className="flex"
            key={year.toString() + "-" + month.toString() + "-" + j.toString()}
          >
            {tdArr}
          </div>
        );
    }
    return result;
  }

  makeDayNumQueue(year, month) {
    var firdayNum = new Date(year + "-" + month + "-1").getDay();
    var dayQueue = [];
    for (var i = firdayNum; dayQueue.length < 7; i++) {
      if (i <= 7) {
        dayQueue.push(i);
      } else {
        dayQueue.push(i - 7);
      }
    }
    return dayQueue;
  }

  render() {
    console.log("render");
    const table = this.makeDayObjArr();
    var list = [];
    var id = [];
    if (this.state.viewList !== null) list = this.makeScheduleList();
    if (this.state.mode === "modify")
      id = <input type="hidden" name="id" value={this.state.diary.ID} />;
    return (
      <div>
        <div className="w-full h-[500px]">
          <div className="flex h-[30px]">
            <div className="flex justify-center items-center flex-1 font-bold border">
              S
            </div>
            <div className="flex justify-center items-center flex-1 font-bold border border-l-0 border-b-0">
              M
            </div>
            <div className="flex justify-center items-center flex-1 font-bold border border-l-0 border-b-0">
              T
            </div>
            <div className="flex justify-center items-center flex-1 font-bold border border-l-0 border-b-0">
              W
            </div>
            <div className="flex justify-center items-center flex-1 font-bold border border-l-0 border-b-0">
              T
            </div>
            <div className="flex justify-center items-center flex-1 font-bold border border-l-0 border-b-0">
              F
            </div>
            <div className="flex justify-center items-center flex-1 font-bold border border-l-0 border-b-0">
              S
            </div>
          </div>
          {table}
        </div>

        {/* ViewModal */}
        {/* <div
          className="modal fade"
          id="viewModal"
          role="dialog"
          aria-labelledby="viewModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="viewModalLabel">
                  {this.state.startDate} 일정보기
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <ul>{list}</ul>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <input
                  type="button"
                  className="btn btn-primary"
                  onClick={this.setStateToWrite}
                  value="Write"
                  data-toggle="modal"
                  data-target="#exampleModal"
                />
              </div>
            </div>
          </div>
        </div> */}

        {/* Write & Modify Modal */}
        {/* <div
          className="modal fade"
          id="exampleModal"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  일정 작성
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form onSubmit={this.saveSchedule}>
                <div className="modal-body">
                  {id}
                  <input type="hidden" name="cmd" value={this.state.mode} />
                  <input type="hidden" name="state" value={this.state.state} />
                  <div className="form-group row">
                    <label className="col-sm-2 col-form-label">시작일</label>
                    <div className="col-sm-5">
                      <input
                        type="date"
                        name="startDate"
                        className="form-control"
                        value={this.state.startDate}
                        onChange={this.startDateSet}
                      />
                    </div>
                    <div className="col-sm-5">
                      <input
                        type="time"
                        name="startTime"
                        className="form-control"
                        value={this.state.startTime}
                        onChange={this.timeSetForStartTime}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-2 col-form-label">종료일</label>
                    <div className="col-sm-5">
                      <input
                        type="date"
                        name="endDate"
                        className="form-control"
                        value={this.state.endDate}
                        onChange={this.endDateSet}
                      />
                    </div>
                    <div className="col-sm-5">
                      <input
                        type="time"
                        name="endTime"
                        className="form-control"
                        value={this.state.endTime}
                        onChange={this.timeSetForEndTime}
                      />
                    </div>
                  </div>

                  <div className="form-group row">
                    <div className="col-sm-4">
                      <select
                        className="custom-select form-control"
                        name="type"
                        defaultValue={this.state.state}
                      >
                        <option name="personal" value="PERSONAL">
                          PERSONAL
                        </option>
                        <option name="personal" value="NOTICE">
                          NOTICE
                        </option>
                        <option name="personal" value="WORK">
                          WORK
                        </option>
                        <option name="personal" value="HOLIDAY">
                          HOLIDAY
                        </option>
                      </select>
                    </div>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        name="title"
                        className="form-control"
                        onChange={this.setTitleForIM}
                        value={
                          this.state.mode == "modify"
                            ? this.state.diary.TITLE
                            : this.state.title
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                  <input
                    type="submit"
                    className="btn btn-primary"
                    value="Save"
                  />
                </div>
              </form>
            </div>
          </div>
        </div> */}
      </div>
    );
  }
}
